import { render, staticRenderFns } from "./delivery-confirm.vue?vue&type=template&id=24c45e24&"
import script from "./delivery-confirm.vue?vue&type=script&lang=js&"
export * from "./delivery-confirm.vue?vue&type=script&lang=js&"
import style0 from "./delivery-confirm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/home/runner/work/myody_front/myody_front/components/button/Button.vue').default,TableGoods: require('/home/runner/work/myody_front/myody_front/components/table/TableGoods.vue').default,Card: require('/home/runner/work/myody_front/myody_front/components/card/Card.vue').default})
